import { twMerge } from "tailwind-merge";

export interface Step {
  label: string;
  value: string;
}

export interface StepperProps {
  steps: Step[];
  selected: Step | null;
  onSelect: (step: Step) => void;
  className?: string;
}

export const Stepper = ({
  steps,
  selected,
  onSelect,
  className,
}: StepperProps) => {
  const selectedStepIndex = selected
    ? steps.findIndex((step) => step.value === selected.value)
    : 0;

  return (
    <div
      className={twMerge("w-full flex flex-nowrap space-x-[-12px] min-w-0", className)}
      data-testid="stepper"
    >
      {steps.map((step, index) => (
        <button
          key={step.label}
          disabled={index > selectedStepIndex}
          className={twMerge(
            "relative flex items-center justify-center flex-1 text-chariot-text-primary min-w-0",
            "px-2 py-3 sm:px-3 sm:py-4 lg:px-4",
            index === 0 && "rounded-l-md",
            index === selectedStepIndex
              ? "bg-chariot-brand-primary"
              : "bg-chariot-stroke",
            index > selectedStepIndex
              ? "text-chariot-text-secondary cursor-not-allowed"
              : "cursor-pointer"
          )}
          style={{
            clipPath:
              index === 0
                ? "polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%)"
                : "polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%, 10% 50%)",
          }}
          onClick={() => {
            onSelect(step);
          }}
        >
          <div
            className={twMerge(
              "absolute top-[2px] bottom-[-2px] right-[-2px] h-[calc(100%-4px)]",
              index === 0
                ? "left-[2px] w-[calc(100%-5px)] rounded-l-[4px]"
                : "left-[5px] w-[calc(100%-8px)]",
              index < selectedStepIndex && "bg-chariot-background-primary",
              index === selectedStepIndex && "bg-chariot-background-secondary",
              index > selectedStepIndex && "bg-chariot-stroke"
            )}
            style={{
              clipPath:
                index === 0
                  ? "polygon(0 0, 90.5% 0, 100% 50%, 90.5% 100%, 0 100%)"
                  : "polygon(0 0, 90.5% 0, 100% 50%, 90.5% 100%, 0 100%, 9.5% 50%)",
            }}
          ></div>
          <span className="z-10 font-bold truncate text-xs sm:text-sm lg:text-base" title={step.label}>
            {step.label}
          </span>
        </button>
      ))}
    </div>
  );
};
